import { getComplianceApiUrl } from "@utils/complianceUrl";
import { getApiUrl } from "@utils/baseUrl";

export const compareTariffApis = {
  landedcostAutosuggest: `${getComplianceApiUrl("intel/suggestTaxableHSCodes")}`,
  getduties: `${getComplianceApiUrl("intel/getduties")}`,
  getcountries: `${getComplianceApiUrl("intel/getcountries")}`,
  generateDutyReport: `${getComplianceApiUrl("intel/generate_duty_report")}`,
  getHsCodeTopCountries: getApiUrl("intelSearchMultiCountryHsCodeTopCountries"),
};
